<template>
  <div class="form">
    <div class="form__header">
      <h3>{{data ? 'Редактировать ДЗ' : 'Добавить ДЗ' }}</h3>
      <div class="help" uk-lightbox="video-autoplay:true;" uk-tooltip="Как задавать домашнее задание">
        <a href="https://www.youtube.com/watch?v=pen0WZoBGUU" data-caption="YouTube" >
          <img src="/themes/genius/assets/img/question.svg" alt="">
        </a>
      </div>
    </div>

    <div class="form__body">
      <form>        
        <div v-if="!data">
          <p class="form__checkbox" v-if="isMaster">
            <input 
              type="checkbox" 
              v-model="is_ah_template"
              id="auto-hw"
            >
            <label for="auto-hw">Автоматическое ДЗ</label>
          </p>

          <div v-if="!is_ah_template">
            <p class="form__field date-field">
              <span>Даты:</span>
              <date-picker
                 :format="'DD-MM-YYYY'"
                v-model="dates"
                valueType="format"
                :multiple="true"
                :disabled-date="date => date < currentDate"
              ></date-picker>
            </p>
            <p class="form__field">
              <span class="l_title">Выберите Учеников</span>
              <v-select label="name" :options="class_students" v-model="students" :multiple="true" :reduce="option => option.id">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name }}
                    </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name }}
                  </div>
                </template>
              </v-select>                
            </p>
            <p class="form__checkbox">            
              <input @change="selectAllStudents" id="all-students" type="checkbox" v-model="allStudents">
              <label for="all-students">Все ученики класса</label>
            </p> 
          </div>
          <div>
            <p class="form__field">
              <span class="l_title">Выберите тренажер</span>        
              <v-select 
                @input="choiseStep" 
                label="title" 
                :options="trainersList" 
                v-model="trainer" 
                :reduce="option => option.component"
              >
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.title }}
                    </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.title }}
                  </div>
                </template>
              </v-select>        
            </p>
            <p class="form__field" v-if="isMaster && is_ah_template">
              <span>Выберите уровень</span>
              <v-select label="text" :options="levels_options" v-model="ah_level" :reduce="option => option.id">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.text }}
                    </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.text }}
                  </div>
                </template>
              </v-select> 
            </p>
          </div>
          <p class="form__checkbox">
            <input 
              @change="choiseStep" 
              type="checkbox" 
              v-model="on_past"
              id="on-past"
            >
            <label for="on-past">На основе прошлых ДЗ</label>
          </p>
        </div>
        
        <OldHwSelect v-if="!data && on_past && oldHomeworks.length > 0" :items="oldHomeworks" @onSelectHW="onSelectHW" />

        <div class="trainer-container" v-if="component">
          <label v-if="trainer !== 'book'">
            <span class="l_title">Количество: </span>
            <div class="plm">
              <div class="plm__button plm__button--minus" @click="addQnt('-', 'qnt')"></div>
              <input type="number" v-model="qnt">
              <div class="plm__button plm__button--plus" @click="addQnt('+', 'qnt')"></div>
            </div>
          </label>
          <component 
            class="instructions" 
            :is="component" 
            :is_homework="true" 
            @params_changed="paramsChanged"
            :homework_params="data ? data.params : null"
          ></component>
        </div>
      </form>
      <div class="form__footer">
        <button type="button" class="uk-button uk-button-primary" :disabled="!component" @click="data ? editHomework() : saveHomework()">Сохранить</button>
      </div>
    </div>    
  </div>
</template>

<script>
import swal from "sweetalert";
import OldHwSelect from "../homeworks/OldHwSelect";
import { mapGetters, mapMutations } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
  name: "add-homework",
  props: ['class_students', 'class_id', 'data'],
  components: {
    OldHwSelect, vSelect
  },
  inject: ['isMaster', 'http'],
  data() {
    return {
      dates: '',
      students: [],
      trainer: null,
      component: null,
      qnt: 1,
      params: '',
      on_past: false,
      oldHomeworks: [],
      oldHomework: '',
      allStudents: false,

      // autohomework
      is_ah_template: false,
      ah_level: 0,
      levels_options: [
        {
          id: '0',
          text: 'Дошкольники'
        },
        {
          id: '1',
          text: 'Младшие школьники'
        },
        {
          id: '2',
          text: 'Старшие школьники'
        },
      ],
    }
  },
  watch: {
    'oldHomework': 'onChangeHomework',
    'is_edit': 'checkEdit'
  },
  computed: {
    ...mapGetters({
      trainers: 'train/trainers'
    }),
    trainersList() {
      let trainers = this.trainers.slice(0)
      trainers.push({
        component: 'book',
        title: 'Чтение книги'
      })
      return trainers
    },
    currentDate() {
      let date = new Date()
      date.setDate(date.getDate() - 1)
      return new Date(date)
    }
  },
  methods: {
    ...mapMutations({
      addTemplate: 'teacher/addTemplate'
    }),
    selectAllStudents() {
      if (this.allStudents) {
        this.students = this.class_students.map(item => item.id)
      } else {
        this.students = []
      }
    },
    choiseStep() {
      if (this.on_past && this.trainer) {
        this.component = null;
        this.oldHomework = '';
        this.loadPastHomeworks();
      }
      if (!this.on_past) {
        this.loader();
      }
      if (!this.trainer && this.on_past) {
        swal('', 'Выберите тренажер', 'warning')
      }
    },
    /** Загружаем компонент тренажера */
    loader() {
      if (!this.trainer) {
        return null
      }
      this.component = require(`../../trainer/${this.trainer}/components/Settings`).default;

    },
    loadPastHomeworks() {
      let data = {
        'class_id': this.class_id,
        'trainer_code': this.trainer,
      }      
      this.http.post('onGetHomeworksByTrainerAndClass', data).then(res => {
        this.oldHomeworks = res.data 
      });
    },
    onSelectHW(item) {
      console.log('select item', item);
      this.oldHomework = item;
      if (item.students_ids) {
        this.students = this.class_students.filter(student => item.students_ids.includes(student.id)).map(item => item.id)
      }      
    },

    async onChangeHomework() {
      if (this.oldHomework) {
        await this.changeTrainerParams();
        await this.loader();
      }
    },
    changeTrainerParams() {
      this.component = null;
      let hw = this.oldHomework;
      this.qnt = hw.qnt;
      let train = this.trainer + '_params';
      let val = {
        train: train,
        params: hw.params,
      }
      this.$store.commit('train/changeParams', val);
    },
    /** Очищаем настройки поля */
    clearSettings() {      
      this.component = null;
      this.trainer = ''; 
    },
    addQnt(val, param, param2) {
      if (!param2) {
        if (val === '+') {
          this[param]++;
        } else if (this[param] > 1) {
          this[param]--;
        }
      } else {
        if (val === '+') {
          this[param][param2]++;
        } else if (this[param][param2] > 1) {
          this[param][param2]--;
        }
      }
    },
    /** Изменение параметров тренажера */
    paramsChanged(data) {
      console.log(data)
      this.$set(this, 'params', data);
    },
    /** Сохраняем домашку */

    saveAutoHomeworkTemplate() {
      let data = {
        'qnt': +this.qnt,
        'params': this.params,
        'trainer': this.trainer,
        'class_id': +this.class_id,
        'is_ah_template': true,
        'level': this.ah_level
      };
      this.$parent.items = '';
      if (data.params.text) {
        data.params.text_title = data.params.text.title;
        data.params.text = '';
      }
      this.http.post('onSaveAHTemplate', data).then(res => {
        this.addTemplate(res.data)
        this.clearSettings();
      })
      
    },
    saveHomework() {
      if (this.is_ah_template) return this.saveAutoHomeworkTemplate();

      if (this.dates && this.students.length) {
        let data = {
          'qnt': this.qnt,
          'params': this.params,
          'dates': this.dates,
          'students': this.students,
          'trainer': this.trainer,
          'class_id': +this.class_id
        };
        this.$parent.items = '';
        if (data.params.text) {
          data.params.text_title = data.params.text.title;
          data.params.text = '';
        }
        console.log(data)
        this.http.post('onAddHomework', data).then(() => {
          this.clearSettings();
          this.$emit('add-homework') 
        })        
      } else {
        swal('Проверьте даты и учеников!', "", "warning");
      }
    },
    editHomework() {
      let data = {
        'qnt': +this.qnt,
        'params': this.params,
        'hw_id': this.data.id,
      };
      this.http.post('onEditHomework', data).then(() => {
        this.$emit('add-homework');
        this.$emit('close-popup');
      });
    },
    async checkEdit() {
      console.log(this.data)
      if (this.data) {
        console.log('Редактируем');
        if (!this.data.trainer) return;
        this.oldHomework = this.data;
        this.trainer = this.data.trainer.component;
        //this.students = this.edit_item.students_ids;
        await this.changeTrainerParams();
        await this.loader();
      }
    }
  },
  created() {
    this.checkEdit()
  },
  mounted() {
    console.log(this.data)
  }
}
</script>

<style lang="scss" scoped>
.form__header {
  display: flex;
  align-items: center;
}
.help {
  margin-left: 10px;
  width: 30px;
  height: 30px;
}

.mx-datepicker {
  width: 100%;
}
.mx-input {
  background-color: #fff !important;
}
.trainer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.instructions {
  width: 100%;
  margin-top: 20px;
}
@media (min-width: 640px) {
  .form {
    width: 600px;
  }
}

</style>